var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.66087C18 2.07955 17.9996 1.78867 17.8838 1.56663C17.7819 1.37132 17.62 1.21265 17.4201 1.11313C17.1928 1 16.8946 1 16.2996 1H2.69958C2.10453 1 1.8073 1 1.58002 1.11313C1.38009 1.21265 1.21767 1.37132 1.11581 1.56663C1 1.78867 1 2.07955 1 2.66087V3.42614C1 3.68002 1 3.80705 1.02936 3.92651C1.05538 4.03242 1.09842 4.13359 1.15668 4.22646C1.22236 4.33118 1.3144 4.4211 1.49805 4.6005L6.87721 9.85554C7.06096 10.0351 7.15234 10.1243 7.21805 10.2291C7.2763 10.3219 7.31992 10.4235 7.34595 10.5294C7.375 10.6476 7.375 10.7731 7.375 11.0219V15.9584C7.375 16.8481 7.375 17.2933 7.56683 17.5613C7.73433 17.7952 7.99274 17.9513 8.28186 17.993C8.61296 18.0408 9.02051 17.842 9.83514 17.4441L10.6851 17.0289C11.0263 16.8623 11.1964 16.7787 11.321 16.6544C11.4312 16.5445 11.5155 16.4125 11.5669 16.267C11.625 16.1025 11.625 15.9158 11.625 15.5432V11.0296C11.625 10.7757 11.625 10.6488 11.6544 10.5294C11.6804 10.4235 11.7234 10.3219 11.7817 10.2291C11.8469 10.125 11.9381 10.036 12.1194 9.85886L12.123 9.85554L17.5022 4.6005C17.686 4.42098 17.7773 4.33121 17.843 4.22646C17.9013 4.13359 17.9449 4.03242 17.9709 3.92651C18 3.80827 18 3.6826 18 3.43386V2.66087Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.780cfc9ef9581fc1c0592b8f0f89b243.svg";
export { ForwardRef as ReactComponent };